/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import PageToolbar from "../../components/PageToolbar";
import { Button, Card, Row, Col, Form, Icon, Input, InputNumber, message } from "antd";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import GenericModal from "../../components/GenericModal";
import ResponsiveTable from "../../components/ResponsiveTable";
import ReportShowButton from "../../components/ReportShowButton";
import moment from "moment";
import SelectorZBranchList from "../../components/SelectorZBranchList";
import GenericTable from "../../components/GenericTable";
import TableLineIcons from "../../components/TableLineIcons";


class TipsDisplay extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            _branchId: '',
            _branchName: '',
            _fromZ: '',
            _toZ: '',
            _fromZStart: null,
            _fromZEnd: null,
            _toZStart: null,
            _toZEnd: null,

            btnZ: '',
            zListData: [],
            inputZFocus: null, // "from" / "to"

            // modals
            modalOpen: false,
            modalDetail: null,      // { rows: [], zNum, dateFrom, dateTo }
            modalViewDoc: null,     // { docs: [], custName }

        };

        this.id = "TIPS_DISPLAY";
        this.detail_id = "TIPS_DETAIL";

        this.api = {
            get: "get_tips_display",
            get_detail: "get_tips_detail",
        };

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        if (props.data[this.detail_id] === undefined) props.data[this.detail_id] = { ...props.data.genericData };
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']';
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22529);
    }


    // ─── Z-range shortcuts ───────────────────────────────────────────────────
    zSetValues = (from, to, btnZ) => {
        let res = {
            _fromZ: from.num,
            _toZ: to.num,
            _fromZStart: moment(from.start).format("YYYY-MM-DD"),
            _fromZEnd: moment(from.end).format("YYYY-MM-DD"),
            _toZStart: moment(to.start).format("YYYY-MM-DD"),
            _toZEnd: moment(to.end).format("YYYY-MM-DD"),
            btnZ,
            inputZFocus: null
        };
        if (parseInt(from.num) > parseInt(to.num)) {
            res._fromZ = to.num;
            res._toZ = from.num;
            res._fromZStart = moment(from.start).format("YYYY-MM-DD");
            res._fromZEnd = moment(from.end).format("YYYY-MM-DD");
            res._toZStart = moment(to.start).format("YYYY-MM-DD");
            res._toZEnd = moment(to.end).format("YYYY-MM-DD");
        }
        if (res._fromZ && res._toZ && moment(res._fromZStart).add(1, "year") < moment(res._toZEnd)) {
            message.error(this.getText(22551));
        } else {
            this.setState(res);
        }
    }

    fillLastZ = () => {
        const { _branchId, zListData } = this.state;
        let findLast = zListData.find(f => f.branch == _branchId);
        if (!findLast) return;
        this.zSetValues(findLast, findLast, 'last');
    }

    fillCurrentMonthZ = () => {
        const { _branchId, zListData } = this.state;
        let fitered = zListData.filter(f => f.branch == _branchId && moment(f.start, "YYYY-MM-DD").isSame(moment(), "month"));
        if (!fitered[0]) return;
        let _fromZ = fitered[0];
        let _toZ = fitered[fitered.length - 1];
        this.zSetValues(_fromZ, _toZ, 'curMonth');
    }

    fillPrevMonthZ = () => {
        const { _branchId, zListData } = this.state;
        let fitered = zListData.filter(f => f.branch == _branchId && moment(f.start, "YYYY-MM-DD").isSame(moment().subtract(1, "month"), "month"));
        if (!fitered[0]) return;
        let _fromZ = fitered[0];
        let _toZ = fitered[fitered.length - 1];
        this.zSetValues(_fromZ, _toZ, 'prevMonth');
    }

    renderDetailBtn = (text, record) => {
        return (<TableLineIcons
            genericIcons={[
                {
                    type: "table",
                    tooltip: this.getText(22566),
                    onClick: () => { this.setState({ modalDetail: record }) }
                }
            ]}
        />)
    }

    renderViewDocBtn = (text, record) => {
        const { dId, dRef2, dCustId, dNum } = record;
        const { headers, data } = this.props.data[this.detail_id]
        let moreDocs = dRef2 ?
            data.map(x => {
                let y = x.split("\f");
                let obj = {}
                headers.forEach((h, i) => { obj[h] = y[i] })
                return obj;
            }).filter(x => x.dRef2 === dRef2 && x.dCustId === dCustId)
            : [record];

        if (moreDocs.length === 1) {
            // no more docs, open the single doc directly
            return this.renderShowBtn(text, record);
        } else {
            return (<TableLineIcons genericIcons={[{ type: "eye", onClick: () => { this.setState({ modalViewDoc: moreDocs }) } }]} />)
        }
    }

    renderShowBtn = (text, record) => {
        return (<ReportShowButton
            {...this.props}
            iconButton
            validSubmit
            params={{
                DocumentNumber: record.dNumber,
                DocumentTypeID: record.dType,
                DocumentPOSID: record.dPos,
                userID: this.props.user.userId,
                userName: encodeURIComponent(this.props.user.displayName),
                isOriginal: '0',
                CentralFatherItem: '0',
                reportName: "reports/DocumentCopy.pdf"
            }}
        />)
    }

    formatSum = (n) => {
        if (!n) return "0.00";
        return parseFloat(n).toLocaleString("he-IL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    formatQty = (n) => {
        if (!n) return "0";
        return parseInt(n).toLocaleString("he-IL", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    formatDateDow = (dt) => {
        if (!dt) return "";
        const m = moment(dt);
        const dow = 'אבגדהוש'.split("")[m.day()];
        return m.format("DD/MM/YYYY") + " " + dow + "'";
    }

    formatDateTime = (dt) => {
        if (!dt) return "";
        return moment(dt).format("DD/MM/YYYY HH:mm");
    }

    render() {
        const gt = this.getText;

        const { _branchId, _fromZ, _toZ, modalOpen, modalDetail, modalViewDoc } = this.state;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexDirection: "column",
        };

        const contentStyle = (<>
            <Form.Item label={gt(22530)} >
                <GenericSelectorBranches
                    {...this.props}
                    value={_branchId}
                    onChange={() => { }}
                    onChangeGetDetailed={({ code, name }) => {
                        this.setState({ _branchId: code, _branchName: name }, this.fillLastZ)
                    }}
                />
            </Form.Item>
            <Form.Item label={gt(22531)} >
                <Icon type="unordered-list" style={{ marginRight: 8 }} onClick={() => this.setState({ inputZFocus: "from" })} />
                <Input style={{ width: 120, display: "inline-block" }} disabled={!_branchId} value={_fromZ} />
                {_fromZ ? <>{" "}  מ  {this.formatDateDow(this.state._fromZStart)} עד {this.formatDateDow(this.state._fromZEnd)}</> : null}
            </Form.Item>
            <Form.Item label={gt(22532)} >
                <Icon type="unordered-list" style={{ marginRight: 8 }} onClick={() => this.setState({ inputZFocus: "to" })} />
                <Input style={{ width: 120, display: "inline-block" }} disabled={!_branchId} value={_toZ} />
                {_toZ ? <>{" "}   מ   {this.formatDateDow(this.state._toZStart)} עד {this.formatDateDow(this.state._toZEnd)}</> : null}
            </Form.Item>

            <Form.Item>
                <Row>
                    {[
                        { key: "last", text: gt(22533), onClick: this.fillLastZ },
                        { key: "curMonth", text: gt(22534), onClick: this.fillCurrentMonthZ },
                        { key: "prevMonth", text: gt(22535), onClick: this.fillPrevMonthZ },
                    ].map(btn => (
                        <Col span={8} key={btn.key}>
                            <div style={{ textAlign: "center" }}>
                                <Button
                                    disabled={!_branchId}
                                    type={this.state.btnZ === btn.key ? 'primary' : 'default'}
                                    onClick={() => this.setState({ btnZ: btn.key }, btn.onClick)}>
                                    {btn.text}
                                </Button>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Form.Item>
        </>)

        const mobileZRender = (text, record) => {
            return (<div>
                <div>{record.zNumber}</div>
                <div style={{ fontSize: 12, color: "gray" }}>
                    מ  {this.formatDateDow(record.minDatetime)}<br />
                    {moment(record.minDatetime).format("HH:mm")}<br />
                    עד  {this.formatDateDow(record.maxDatetime)}<br />
                    {moment(record.maxDatetime).format("HH:mm")}
                </div>
            </div>)
        }

        const mobileSumHRender = (text,record) => {
            return (<div>
                <div>{this.formatSum(record.sumH)}</div>
                <div style={{ fontSize: 12, color: "gray" }}>
                    ({this.formatQty(record.qtyH)})
                </div>
            </div>)
        }

        const mobileSumZRender = (text,record) => {
            return (<div>
                <div>{this.formatSum(record.sumZ)}</div>
                <div style={{ fontSize: 12, color: "gray" }}>
                    ({this.formatQty(record.qtyZ)})
                </div>
            </div>)
        }

        return (
            <div style={divStyle}>

                {this.props.isModalAutoIphone ?
                    <GenericModal
                        visible
                        title={gt(22529)}
                        onCancel={this.props.onCancel}
                        width={window.innerWidth < 600 ? "95%" : 500}
                        footer={[
                            <Button style={{ marginLeft: 5 }} onClick={this.props.onCancel}>{gt(22537)}</Button>,
                            <Button type="primary" disabled={!_branchId} onClick={() => { this.setState({ modalOpen: true }) }}>{gt(22536)}</Button>,
                        ]}
                    >{contentStyle}</GenericModal>
                    : <Card
                        title={<PageToolbar title={gt(22529)} showsearch={false} actionButtons={[]} />}
                        bordered={true}
                        style={{ width: window.innerWidth < 600 ? "95%" : 500 }}
                        headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
                        actions={[
                            <Button type="primary" disabled={!_branchId} onClick={() => { this.setState({ modalOpen: true }) }}>{gt(22536)}</Button>,
                            <Button onClick={() => this.setState({ _branchId: '', _fromZ: '', _toZ: '' })}>{gt(22537)}</Button>
                        ]}
                    >{contentStyle}</Card>}


                <SelectorZBranchList
                    {...this.props}
                    isModalOnly
                    visible={this.state.inputZFocus !== null}
                    getZListOnOpen={list => { this.setState({ zListData: list }) }}
                    filters={{ zNumber: null, branchId: _branchId }}
                    onChange={obj => {
                        let res = { num: obj.zNumber, start: obj.StartDate, end: obj.EndDate }
                        let from = this.state.inputZFocus === "from" ? res : { num: this.state._fromZ, start: this.state._fromZStart, end: this.state._fromZEnd };
                        let to = this.state.inputZFocus === "to" ? res : { num: this.state._toZ, start: this.state._toZStart, end: this.state._toZEnd };
                        this.zSetValues(from, to, null);
                    }}
                />

                <GenericModal
                    visible={modalOpen}
                    title={<>{gt(22554)} {this.state._branchId} {this.state._branchName}</>}
                    onCancel={() => this.setState({ modalOpen: false })}
                >
                    {modalOpen && <GenericTable
                        {...this.props}
                        tableOnly
                        id={this.id}
                        getApi={this.api.get}
                        filters={{ _branchId, _fromZ, _toZ }}
                        columns={
                            window.innerWidth < 600 ? [
                                { title: gt(22558), dataIndex: 'zNumber', key: 'zNumber', width: '40%', render: mobileZRender },
                                { title: gt(22561), dataIndex: 'sumH', key: 'sumH', width: '20%', render: mobileSumHRender },
                                { title: gt(22563), dataIndex: 'sumZ', key: 'sumZ', width: '20%', render: mobileSumZRender },
                                { title: gt(22565), width: '20%', render: this.renderDetailBtn },
                            ] : [
                                { title: gt(22558), dataIndex: 'zNumber', key: 'zNumber', width: '14%' },
                                { title: gt(22559), dataIndex: 'minDatetime', key: 'minDatetime', width: '14%', render: this.formatDateDow },
                                { title: gt(22560), dataIndex: 'maxDatetime', key: 'maxDatetime', width: '14%', render: this.formatDateDow },
                                { title: gt(22561), dataIndex: 'sumH', key: 'sumH', width: '12%', render: this.formatSum },
                                { title: gt(22562), dataIndex: 'qtyH', key: 'qtyH', width: '12%', render: this.formatQty },
                                { title: gt(22563), dataIndex: 'sumZ', key: 'sumZ', width: '12%', render: this.formatSum },
                                { title: gt(22564), dataIndex: 'qtyZ', key: 'qtyZ', width: '12%', render: this.formatQty },
                                { title: gt(22565), width: '10%', render: this.renderDetailBtn },
                            ]}
                    />}
                </GenericModal>

                <GenericModal
                    visible={modalDetail !== null}
                    title={<>{gt(22573)} {modalDetail?.zNumber}</>}
                    onCancel={() => this.setState({ modalDetail: null })}
                    width={1000}
                >
                    {modalDetail && <GenericTable
                        {...this.props}
                        tableOnly
                        id={this.detail_id}
                        getApi={this.api.get_detail}
                        filters={{ zNumber: modalDetail.zNumber }}
                        columns={[
                            { title: gt(22567), dataIndex: 'dTimestamp', key: 'dTimestamp', width: '15%', render: this.formatDateTime },
                            { title: gt(22568), dataIndex: 'dNumber', key: 'dNumber', width: '15%' },
                            { title: gt(22569), dataIndex: 'dCustName', key: 'dCustName', width: '25%' },
                            { title: gt(22570), dataIndex: 'dSum', key: 'dSum', width: '15%', render: this.formatSum },
                            { title: gt(22571), dataIndex: 'dEmployeeName', key: 'dEmployeeName', width: '20%' },
                            { title: gt(22572), width: '10%', render: this.renderViewDocBtn },
                        ]}
                        percentageToMobile={[37,0,37,26]}
                    />}
                </GenericModal>

                <GenericModal
                    visible={modalViewDoc !== null}
                    title={gt(22574) + " " + modalViewDoc?.[0]?.dRef2}
                    onCancel={() => this.setState({ modalViewDoc: null })}
                    width={800}
                >
                    {modalViewDoc && <ResponsiveTable
                        {...this.props}
                        tableOnly
                        dataSource={modalViewDoc}
                        columns={[
                            { title: gt(22567), dataIndex: 'dTimestamp', key: 'dTimestamp', width: '20%', render: this.formatDateTime },
                            { title: gt(22568), dataIndex: 'dNumber', key: 'dNumber', width: '20%' },
                            { title: gt(22569), dataIndex: 'dCustName', key: 'dCustName', width: '30%' },
                            { title: gt(22570), dataIndex: 'dSum', key: 'dSum', width: '20%', render: this.formatSum },
                            { title: gt(22572), width: '10%', render: this.renderShowBtn },
                        ]}
                    />}
                </GenericModal>
            </div>
        );
    }
}

export default TipsDisplay;